import { CALL_API } from '../middleware/api'

import { fetchEnrolments } from './enrolments.js'
import { loadMember } from './member.js'
 
export const INVOICES_REQUEST = 'INVOICES_REQUEST'
export const INVOICES_SUCCESS = 'INVOICES_SUCCESS'
export const INVOICES_FAILURE = 'INVOICES_FAILURE'

export const INVOICE_REQUEST = 'INVOICE_REQUEST'
export const INVOICE_SUCCESS = 'INVOICE_SUCCESS'
export const INVOICE_FAILURE = 'INVOICE_FAILURE'

export const PP_CAPTURE_REQUEST = 'PP_CAPTURE_REQUEST'
export const PP_CAPTURE_SUCCESS = 'PP_CAPTURE_SUCCESS'
export const PP_CAPTURE_FAILURE = 'PP_CAPTURE_FAILURE'

export const fetchInvoices = (from_date, to_date, refresh = false) => (dispatch, getState) => {
	
	const invoices = getState().invoices;
	const now = Math.floor(Date.now() / 1000);
	if (!refresh && invoices && invoices.expires >= now && from_date >= invoices.from && to_date <= invoices.to) {
		return null
	}
	
	const user = getState().user;
	
	return dispatch({
		[CALL_API]: {
			types: [ INVOICES_REQUEST, INVOICES_SUCCESS, INVOICES_FAILURE ],
			endpoint: '/invoices/',
			method: 'POST',
			params: {
				member_no: user.member_no,
				from_date: from_date,
				to_date: to_date,
			},
			bad_response: 'Error fetching invoices from U-MAS database',
			add_data: {
				from: from_date,
				to: to_date
			}
		}
	})
}

export const fetchInvoice = (invoice_no, refresh = false) => (dispatch, getState) => {

	const user = getState().user;
	
	const invoices = getState().invoices.singles;
	
	if(!refresh && invoices[invoice_no] && !invoices[invoice_no].error){
		return null;
	}
	
	return dispatch({
		[CALL_API]: {
			types: [ INVOICE_REQUEST, INVOICE_SUCCESS, INVOICE_FAILURE ],
			endpoint: '/invoices/' + invoice_no,
			method: 'POST',
			params: {
				member_no: user.member_no,
			},
			bad_response: 'Error fetching invoice from U-MAS database',
			add_data: {
				invoice_no: invoice_no
			}
		}
	})
}

export const capturePayPalPayment = (order_no, invoice_no) => (dispatch, getState) => {
	const user = getState().user;
	
	const params = {
		paypal_order_no: order_no,
		invoice_no: invoice_no,
		member_no: user.member_no
	}

	return dispatch({
		[CALL_API]: {
			types: [ PP_CAPTURE_REQUEST, PP_CAPTURE_SUCCESS, PP_CAPTURE_FAILURE ],
			endpoint: '/paypal_capture/',
			method: 'POST',
			params: params,
			bad_response: 'Error capturing PayPal payment for invoice '+invoice_no,
			add_data: {
				invoice_no: invoice_no
			}
		}
	}).then(result => {
		dispatch(loadMember(true));
		dispatch(fetchEnrolments(null, null, true));
	})
		
}